/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  BoardScaledEvent,
  IterationUpdatedEvent,
  NoData,
  ObjectiveCreatedEvent,
  ObjectiveUpdatedEvent,
  ShapeCreatedEvent,
  ShapeDeletedEvent,
  ShapeUpdatedEvent,
  StickyCreatedEvent,
  StickyUpdateEndedEvent,
  StickyUpdatedEvent,
  TopStickyEvent,
} from "./models";

export class BoardApiPublisher {
  constructor(private caller: ApiCaller) {}

  async stickyCreated(
    payload: StickyCreatedEvent,
    sessionId: string,
    boardId: string,
    stickyId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.created",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          stickyId: String(stickyId),
        },
      },
      "stickyCreated",
      payload,
      { publish: true },
    );
  }

  async stickyUpdateStarted(
    payload: NoData,
    sessionId: string,
    boardId: string,
    stickyId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky_update.${stickyId}.started",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          stickyId: String(stickyId),
        },
      },
      "stickyUpdateStarted",
      payload,
      { publish: true },
    );
  }

  async stickyUpdated(
    payload: StickyUpdatedEvent,
    sessionId: string,
    boardId: string,
    stickyId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.updated",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          stickyId: String(stickyId),
        },
      },
      "stickyUpdated",
      payload,
      { publish: true },
    );
  }

  async stickyUpdateEnded(
    payload: StickyUpdateEndedEvent,
    sessionId: string,
    boardId: string,
    stickyId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky_update.${stickyId}.ended",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          stickyId: String(stickyId),
        },
      },
      "stickyUpdateEnded",
      payload,
      { publish: true },
    );
  }

  async stickyDeleted(
    payload: NoData,
    sessionId: string,
    boardId: string,
    stickyId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.deleted",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          stickyId: String(stickyId),
        },
      },
      "stickyDeleted",
      payload,
      { publish: true },
    );
  }

  async iterationUpdated(
    payload: IterationUpdatedEvent,
    sessionId: string,
    boardId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.iteration.updated",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "iterationUpdated",
      payload,
      { publish: true },
    );
  }

  async objectiveCreated(
    payload: ObjectiveCreatedEvent,
    sessionId: string,
    boardId: string,
    objectiveId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.created",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          objectiveId: String(objectiveId),
        },
      },
      "objectiveCreated",
      payload,
      { publish: true },
    );
  }

  async objectiveDeleted(
    payload: NoData,
    sessionId: string,
    boardId: string,
    objectiveId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.deleted",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          objectiveId: String(objectiveId),
        },
      },
      "objectiveDeleted",
      payload,
      { publish: true },
    );
  }

  async objectiveUpdated(
    payload: ObjectiveUpdatedEvent,
    sessionId: string,
    boardId: string,
    objectiveId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.updated",
        variables: {
          sessionId: String(sessionId),
          boardId: String(boardId),
          objectiveId: String(objectiveId),
        },
      },
      "objectiveUpdated",
      payload,
      { publish: true },
    );
  }

  async shapeCreated(
    payload: ShapeCreatedEvent,
    sessionId: string,
    boardId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.created",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "shapeCreated",
      payload,
      { publish: true },
    );
  }

  async shapeUpdated(
    payload: ShapeUpdatedEvent,
    sessionId: string,
    boardId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.updated",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "shapeUpdated",
      payload,
      { publish: true },
    );
  }

  async shapeDeleted(
    payload: ShapeDeletedEvent,
    sessionId: string,
    boardId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.deleted",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "shapeDeleted",
      payload,
      { publish: true },
    );
  }

  async scaleUpdated(payload: BoardScaledEvent, sessionId: string, boardId: string): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.scale.updated",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "scaleUpdated",
      payload,
      { publish: true },
    );
  }

  async topStickyUpdated(
    payload: TopStickyEvent,
    sessionId: string,
    boardId: string,
  ): Promise<void> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.top_sticky.updated",
        variables: { sessionId: String(sessionId), boardId: String(boardId) },
      },
      "topStickyUpdated",
      payload,
      { publish: true },
    );
  }
}
